import { timeFormat } from "../data/main";

export const convertHour = (hour: string) => {
  try {
    if (hour.length > 1) {
      let hours = hour.split(":").slice(0, 2);
      if (timeFormat.fullTime) {
        hour = hours.join(":");
        if (hour.length > 0 && hour[0] === "0") {
          hour = hour.slice(1);
        }
      } else if (hours.length > 1) {
        let theHour = Number(hours[0]) - 12;
        let minutes = `${hours[1]} ${
          theHour === 12 || theHour < 0 ? "a.m." : "p.m."
        }`;

        hour = `${
          theHour === -12 ? 12 : theHour < 1 ? theHour + 12 : theHour
        }:${minutes}`;
      }
    }
  } catch (error) {
    console.log("convertHour: ", error);
  }
  return hour;
};
